import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCollection } from '../../actions/index';
import Gallery from './gallery/Gallery';

class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      portfolio: [],
    }
  }

  componentWillMount() {
    this.props.getCollection('galeria').then(() => {
      if (this.props.collection) {
        this.setState({
          isLoading: false,
          portfolio: this.props.collection.entries,
        });
      };
    });
  }

  render() {
    const { isLoading, portfolio } = this.state;

    if (isLoading) {
      return <div className="loading" />
    }

    return (
      <div>
        <Gallery portfolio={portfolio} />
      </div >
    );
  }
}
function mapStateToProps(state) {
  return { collection: state.collection.collection };
}
export default connect(mapStateToProps, { getCollection })(Portfolio);



// WEBPACK FOOTER //
// ./src/components/portfolio/Portfolio.js